/**************************************************
 * Nombre:       Tarjeta_Pedidos_Realizados
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Button, Grid, Typography} from "@mui/material";
import {formatoFecha} from "../../Modulo_Carrito_Wass/Utilidades/formatoFecha";
import Tarjeta_Pedidos_Producto from "./Tarjeta_Pedidos_Producto";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import {useFuncionesCarrito} from "../../Modulo_Carrito_Wass/Hooks/useFuncionesCarrito";
import {useState} from "react";
import {obtenerColeccionQuery} from "../../Servicios/BD/obtenerColeccionQuery";
import {collection, or, query, where} from "firebase/firestore";
import {fire} from "../../fire";
import {useCarritoCompras} from "../../Modulo_Carrito_Wass/Hooks/useCarritoCompras";
import {adap_producto} from "../../Modulo_Carrito_Wass/Adaptadores/adap_producto";
import {useResponsive} from "../../Modulo_Responsive/Hooks/useResponsive";

const Tarjeta_Pedidos_Realizados = ({item}) => {
    const {sCell} = useResponsive()
    const {adicionarProducto} = useFuncionesCarrito()
    const {DialogoCarrito, abrir} = useCarritoCompras()
    const [cargando, setCargado] = useState(false)

    const agregarProductos = async () => {

        let productos = item.productos
        setCargado(true)

        let ws = productos.map((it, index) => {
            return where('id', '==', it.id)
        })

        let q = query(collection(fire, 'productos'), or(...ws))

        let doxProd = await obtenerColeccionQuery(q)

        if (doxProd.res) {

            let prodsAct = doxProd.data

            for (let i = 0; i < prodsAct.length; i++) {
                adicionarProducto(adap_producto({
                    producto: prodsAct[i]
                }))
            }
        }

        abrir()
        setCargado(false)


    }

    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{
                backgroundColor: '#FFF',
                border: 0.5,
                borderColor: 'rgba(0, 0, 0, 0.2)',
                filter: 'drop-shadow(0px 2px 20px rgba(0, 0, 0, 0.10))',
                p: 2,
                borderRadius: 1.5
            }}
        >

            <DialogoCarrito/>

            <Grid container size={{xs: 12, sm: 12, md: 12}}>
                <Typography sx={{fontWeight: 600}}>{`Fecha: ${formatoFecha(item.fecha)}`}</Typography>
            </Grid>

            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                spacing={2}
                sx={{mt: 1}}
            >


                {item?.productos.map((it, index) => {
                    return (
                        <Grid container size={{xs: 12, sm: 6, md: 4}}>
                            <Tarjeta_Pedidos_Producto item={it}/>
                        </Grid>
                    )
                })}

            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: sCell ? 'center' : 'flex-end', mt: 2}}>
                <Button
                    onClick={() => agregarProductos()}
                    loading={cargando} startIcon={<ShoppingCartIcon/>}>Agrear todo a carrito</Button>
            </Grid>


        </Grid>
    )

}
export default Tarjeta_Pedidos_Realizados

